import * as Yup from 'yup';

export const talkingPointsValidationSchema = Yup.object({
  talkingPoints: Yup.string().optional(),
});
